import Page from "../../../modules/Core/Components/Page";
import templateDefault from "../../templates/default/pages/collection";
import { getLastNavigationAction } from "../../utils/scroll-restoration";

export default class Collection extends Page {
  template = templateDefault;

  onAuth() {
    this.refresh();
  }

  onLoad(data) {
    super.onLoad(data);
    this.loadCollection(true);
  }

  onUpdate(prevProps, prevState, snapshot) {
    super.onUpdate(prevProps, prevState, snapshot);

    const newPage =
      prevProps.location.pathname !== this.props.location.pathname;
    const isBackNavigation = getLastNavigationAction() === "POP";

    if (newPage || prevProps.location.search !== this.props.location.search) {
      this.loadCollection(newPage && !isBackNavigation);
    }
  }

  loadCollection(newPage) {
    this.getComponents()
      .findById("collection")
      .forEach((c) => {
        c.loadCollection(newPage);
      });

    return this;
  }
}
